"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_18)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_18`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#EF3340"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V8H-6V0Z",
					fill: "#00B5E2"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 16H30V24H-6V16Z",
					fill: "#509E2F"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6386 14.9193C11.0246 14.9193 9.71934 13.614 9.71934 12C9.71934 10.3859 11.0246 9.08067 12.6386 9.08067C13.1439 9.08067 13.6141 9.20698 14.0281 9.43154C13.3825 8.79996 12.4913 8.40698 11.5158 8.40698C9.52987 8.40698 7.92285 10.014 7.92285 12C7.92285 13.9859 9.52987 15.5929 11.5158 15.5929C12.4913 15.5929 13.3825 15.2 14.0281 14.5684C13.6141 14.7929 13.1439 14.9193 12.6386 14.9193Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.8842 9.97888L15.2702 11.0666L16.3158 10.5684L15.8175 11.614L16.9053 11.9999L15.8175 12.3859L16.3158 13.4315L15.2702 12.9333L14.8842 14.021L14.4982 12.9333L13.4526 13.4315L13.9509 12.3859L12.8632 11.9999L13.9509 11.614L13.4526 10.5684L14.4982 11.0666L14.8842 9.97888Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_18`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AZFlag };
